// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"2979": "57c2bf02","3996": "6395431b",}[chunkId] + ".chunk.css"
}